export default __webpack_public_path__ + "static/media/settings.254fa9fe.svg";